import { App as AntApp, ConfigProvider } from "antd";
import axios from "axios";
import { Theme } from "components/Endeavour";
import { useState } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { RouterProvider } from "react-router-dom";
import router from "./router";

import "@aws-amplify/ui-react/styles.css";
import "./App.css";

import AppContext from "AppContext";
import withAuthenticator from "components/withAuthenticator";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: 0,
      // cacheTime: 0,
      refetchOnWindowFocus: false,
    },
  },
});

// axios.defaults.baseURL = "http://localhost/resources/card-programs/b58ad182-f15d-42df-9231-ad634a78b0de";
// axios.defaults.baseURL = "https://endeavour.uat.pa-g.com/resources/card-programs/b58ad182-f15d-42df-9231-ad634a78b0de";
axios.defaults.baseURL = "http://localhost";
axios.defaults.timeout = 10000;

function App({ user, signOut }) {
  const [login, setLogin] = useState(true);
  return (
    <AppContext.Provider
      value={{ login: login, setLogin: setLogin, signOut: signOut, user: user }}
    >
      <AntApp>
        <QueryClientProvider client={queryClient}>
          <ConfigProvider
            theme={{
              ...Theme,
            }}
          >
            <RouterProvider router={router} />
          </ConfigProvider>
        </QueryClientProvider>
      </AntApp>
    </AppContext.Provider>
  );
}

export default withAuthenticator(App);
